import React from 'react';

export const userRoute = [
  {
    path: '/user',
    component: React.lazy(() => import('@/views/community/homeDetail')),
    meta: {
      title: '个人中心'
    },
    children: [
      {
        path: '/user/personal',
        component: React.lazy(() => import('@/views/user/personal')),
        meta: {
          title: '个人中心',
          crumbs: 1000
        },
        children: [
          {
            path: '/user/personal/credit',
            component: React.lazy(() => import('@/views/user/credit')),
            meta: {
              title: '信用分'
            },
            children: [
              {
                path: '/user/personal/credit/particulars',
                component: React.lazy(() => import('@/views/user/credit/particulars')),
                meta: {
                  title: '信用分明细'
                }
              },
              {
                path: '/user/personal/credit/rules',
                component: React.lazy(() => import('@/views/user/credit/rules')),
                meta: {
                  title: '信用分规则'
                }
              }
            ]
          },
          {
            path: '/user/personal/editProfile',
            component: React.lazy(() => import('@/views/user/editProfile')),
            meta: {
              title: '编辑资料'
            }
          },
          {
            path: '/user/trumpetManage',
            component: React.lazy(() => import('@/views/user/trumpetManage')),
            meta: {
              title: '小号管理'
            }
          },
          {
            path: '/user/personal/authentication',
            component: React.lazy(() => import('@/views/user/authentication')),
            meta: {
              title: '身份认证',
              crumbs: 1000
            },
            children: [
              {
                path: '/user/personal/authentication/understand',
                component: React.lazy(() => import('@/views/user/authentication/understand')),
                meta: {
                  title: '了解认证',
                  crumbs: 1000
                }
              }
            ]
          },
          {
            path: '/user/personal/certification',
            component: React.lazy(() => import('@/views/user/certification')),
            meta: {
              title: '实名认证'
            }
          },
          {
            path: '/user/personal/address',
            component: React.lazy(() => import('@/views/user/address')),
            meta: {
              title: '收货地址管理'
            }
          },
          {
            path: '/user/personal/wallet',
            component: React.lazy(() => import('@/views/user/wallet')),
            meta: {
              title: '钱包'
            },
            children: [
              {
                path: '/user/personal/wallet/boxCurrency',
                component: React.lazy(() => import('@/views/user/wallet/boxCurrency')),
                meta: {
                  title: '盒币充值'
                }
              },
              {
                path: '/user/personal/wallet/goldWithdraw',
                component: React.lazy(() => import('@/views/user/wallet/withdraw')),
                meta: {
                  title: '金币提现'
                }
              },
              {
                path: '/user/personal/wallet/voucher',
                component: React.lazy(() => import('@/views/user/wallet/voucher')),
                meta: {
                  title: '充值券',
                  crumbs: 1000
                },
                children: [
                  {
                    path: '/user/personal/wallet/voucher/recharge',
                    component: React.lazy(() => import('@/views/user/wallet/voucher/voucherRecharge')),
                    meta: {
                      title: '充值'
                    }
                  },
                  {
                    path: '/user/personal/wallet/voucher/gameRecharge',
                    component: React.lazy(() => import('@/views/user/wallet/voucher/voucherGameRecharge')),
                    meta: {
                      title: '游戏充值'
                    }
                  }
                ]
              }
            ]
          },
          {
            path: '/user/personal/silkNoodles',
            component: React.lazy(() => import('@/views/user/silkNoodles')),
            meta: {
              title: '关注列表页',
              crumbs: 840
            }
          },
          {
            path: '/user/personal/fansNoodles',
            component: React.lazy(() => import('@/views/user/silkNoodles')),
            meta: {
              title: '粉丝列表页',
              crumbs: 840
            }
          },
          {
            path: '/user/personal/member',
            component: React.lazy(() => import('@/views/user/member')),
            meta: {
              title: 'SVIP成长体系',
              crumbs: 1000
            }
          },
          {
            path: '/user/personal/CloudPhone',
            component: React.lazy(() => import('@/views/user/member/CloudPhone')),
            meta: {
              title: 'SVIP云手机权益',
              crumbs: 1000
            }
          },
          {
            path: '/user/personal/Integral',
            component: React.lazy(() => import('@/views/user/member/Integral')),
            meta: {
              title: 'SVIP积分权益',
              crumbs: 1000
            }
          },
          {
            path: '/user/personal/member/ProofOfStake',
            component: React.lazy(() => import('@/views/user/proofOfStake')),
            meta: {
              title: '权益说明',
              crumbs: 1000
            }
          },
          {
            path: '/user/personal/member/Grouth',
            component: React.lazy(() => import('@/views/user/Grouth')),
            meta: {
              title: '成长值明细',
              crumbs: 1000
            }
          }
        ]
      }
    ]
  },
  {
    path: '/user/commonityDetail',
    component: React.lazy(() => import('@/views/community/homeDetail')),
    meta: {
      title: '帖子详情'
    }
  },
  {
    path: '/user/creatorRankPage',
    component: React.lazy(() => import('@/views/community/h5/creatorRankPage')),
    meta: {
      title: '榜单'
    }
  },
  {
    path: '/user/creatorRewardPage',
    component: React.lazy(() => import('@/views/community/h5/creatorRewardPage')),
    meta: {
      title: '创作者计划'
    }
  }
];
